import { render, staticRenderFns } from "./edit_box.vue?vue&type=template&id=587b66dc&scoped=true"
import script from "./edit_box.vue?vue&type=script&lang=js"
export * from "./edit_box.vue?vue&type=script&lang=js"
import style0 from "./edit_box.vue?vue&type=style&index=0&id=587b66dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587b66dc",
  null
  
)

export default component.exports